const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCleaner(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 32.65050507,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "M26.849 957.362a1.764 1.764 0 0 0-1.737 1.789v21.54a2.88 2.88 0 0 0-.594 5.581c.204.074.393.139.594.21v35.509h3.527v-34.293c3.825 1.229 6.994 1.838 10.213 1.069 3.354-.801 6.017-3.046 8.786-6.648v27.234h.002v33.838a4.113 4.113 0 1 0 8.226 0v-33.838h3.46v33.838a4.113 4.113 0 1 0 8.226 0v-60.295l9.104 15.77c-2.152 1.39-3.57 4.099-3.57 7.123h-.332a1.615 1.615 0 0 0-1.592 1.889l2.154 12.53a1.615 1.615 0 0 0 .732 1.094s.634.369 1.585.626c.95.257 2.354.49 4.31.49 1.954 0 3.357-.233 4.308-.49.951-.257 1.585-.626 1.585-.626a1.615 1.615 0 0 0 .732-1.093l2.154-12.531a1.615 1.615 0 0 0-1.592-1.889h-.332c0-3.204-1.592-6.052-3.961-7.354a2.88 2.88 0 0 0-.402-1.275l-12.39-21.46a2.88 2.88 0 0 0-2.493-1.472H47.639v.01a2.88 2.88 0 0 0-.064 0 2.88 2.88 0 0 0-2.336 1.322c-3.467 5.234-5.626 7.111-7.725 7.613-1.814.434-4.507-.09-8.874-1.557v-22.459a1.764 1.764 0 0 0-1.79-1.788zm30.729 0c-4.045 0-7.335 3.29-7.335 7.335a7.327 7.327 0 0 0 7.335 7.334c4.07 0 7.368-3.264 7.368-7.334 0-4.045-3.298-7.335-7.368-7.335zm19.969 42.835a2.88 2.88 0 0 0 4.82.023c1.564 1.061 2.666 3.118 2.666 5.57H74.85c0-2.47 1.117-4.538 2.698-5.592zM24.33 1023.05a1.764 1.764 0 1 0 0 3.527h5.089a1.764 1.764 0 1 0 0-3.527h-5.09zm2.063 4.334a7.565 7.565 0 0 0-2.843.577c-2.084.872-3.707 2.712-4.227 4.936-.377 1.614-.192 3.065-.435 4.201a5.21 5.21 0 0 1-2.402 3.326 5.21 5.21 0 0 1-4.075.473c-1.027-.316-1.818.922-.35 2.446 1.47 1.523 3.613 2.793 5.944 3.463a14.4 14.4 0 0 0 7.895.01c1.908-.543 3.719-1.493 5.21-2.85 1.494-1.36 2.644-3.114 3.21-5.086.565-1.975.523-4.13-.225-6.077-.75-1.953-2.2-3.63-4.096-4.581a7.914 7.914 0 0 0-3.606-.838z",
    transform: "translate(0 -952.362)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaner);
export default __webpack_public_path__ + "static/media/cleaner.3c088674780026aef87e88ddd5f3ad19.svg";
export { ForwardRef as ReactComponent };